// eslint-disable-next-line max-classes-per-file
import React, {ReactNode} from 'react';
import I18n from 'app/i18n';
import DefaultRegistrationNew from './DefaultRegistrationNew';
import FastRegistrationPromocode from 'app/components/auth/FastRegistrationPromocode';
import FastRegistrationTerms from 'app/components/auth/FastRegistrationTerms';
import {DefaultRegistrationInterface} from 'app/interfaces/DefaultRegistrationInterface';
import {flagsStore} from 'app/store/global';

export default class FastRegistrationWithEmailContent extends DefaultRegistrationNew {
    static LEAD_FIELDS = ['password', 'email'];

    static METHOD = 'fast';

    constructor(props: DefaultRegistrationInterface) {
        super(props);
        this.toggleCountryCode = this.toggleCountryCode.bind(this);
    }

    toggleCountryCode():void {
        this.setState(prevState => ({
            countrySelectorVisible: !prevState.countrySelectorVisible
        }));
    }

    getCountryName(): string {
        const country = flagsStore.flags.find(item => item.code === window.CURRENT_IP_COUNTRY);
        return country?.name;
    }

    render(): ReactNode {
        return this.state.success
            ? <div>{this.state.success}</div>
            : <form id="fast-sign-up" onSubmit={this.signUp} ref={this.rootForm}
                className="form-popup popup-form--error" autoComplete="new-password">
                <span className="form-title">{I18n.t('register')}</span>
                <div className="fast-registration-with-email">
                    <input
                        name="site_lang"
                        type="hidden"
                        value={window.settings.config.lang}
                    />
                    <input name="full_registered" type="hidden" value="0"/>
                    {this.rowName()}
                    {this.rowEmail()}
                    {this.rowPassword(true)}
                    {!this.state.countrySelectorVisible &&
                        <div className="fast-registration-user-country">
                            <span className="user-country-title">{`${I18n.t('user_country') } ${ this.getCountryName()}`}?</span>
                            <button
                                type="button"
                                className="button-user-country"
                                onClick={this.toggleCountryCode}
                            >
                                {I18n.t('change')}
                            </button>
                        </div>
                    }
                    {this.state.countrySelectorVisible && this.rowCountryCode()}
                    {this.rowCaptcha()}
                    <FastRegistrationPromocode/>
                    <FastRegistrationTerms/>
                    <div className="popup-form__submit-row">
                        {this.renderRegisterButton(I18n.t('chek_up'))}
                    </div>
                </div>
            </form>;
    }
}
